// @ts-nocheck
import { ScrollContext, ScrollContextModel } from "@store/Framework/Components/ScrollContext/ScrollContext";
import React, { FC, useState } from "react";

const ScrollContextProvider: FC = ({ children }) => {
    const [scroll, setScroll] = useState(0);

    const providerValue: ScrollContextModel = {
        scroll,
        setScroll,
    };

    return <ScrollContext.Provider value={providerValue}>{children}</ScrollContext.Provider>;
};

export default ScrollContextProvider;
